import { FC, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./styles/App.css";
import { ClientSite } from "./ClientSite";
import { Wizard } from "../components/Wizard";
import { BJS } from "../pages/Subservices/BJS";
import { CPWM } from "../pages/Subservices/CPWM";
import { PJW } from "../pages/Subservices/PJW";
import { APSS } from "../pages/Subservices/APSS";
import { BOC } from "../pages/Subservices/BOC";
import { EXXM } from "../pages/Subservices/ExxpressMart";
import useWizardContext from "../context/wizard/hooks/useWizardContext";
import { CIRK } from "../pages/Subservices/CIRK";
import { CHPE } from "../pages/Subservices/CHPE";
import { HHM } from "../pages/Subservices/HHM";
import { LRG } from "../pages/Subservices/LRG";

const subserviceRoutes = [
	{ path: "/bjs/*", element: <BJS /> },
	{ path: "/cpwm/*", element: <CPWM /> },
	{ path: "/pjwrg/*", element: <PJW /> },
	{ path: "/aplus/*", element: <APSS /> },
	{ path: "/boc/*", element: <BOC /> },
	{ path: "/circlek/*", element: <CIRK /> },
	{ path: "/chpe/*", element: <CHPE /> },
	{ path: "/hhm/*", element: <HHM /> },
	{ path: "/lrg/*", element: <LRG /> },
	{ path: "/exxpressmart/*", element: <EXXM /> },
	{ path: "/exxpressmart.html/*", element: <EXXM /> },
];

const App: FC = () => {
	useEffect(() => {
		function blockIndexing() {
			const meta = document.createElement("meta");
			meta.name = "robots";
			meta.content = "noindex";
			window.document.head.appendChild(meta);
			console.info(
				`${window.location.host} blocked robots from indexing.`
			);
		}
		if (process.env.NODE_ENV !== "production") blockIndexing();
	}, []);

	const {
		state: { wizardRequested, wizardUrl },
	} = useWizardContext();

	return (
		<>
			{wizardRequested && <Wizard src={wizardUrl} />}
			<Routes>
				<Route path="/*" element={<ClientSite />} />

				{/* SUBSERVICES */}
				{subserviceRoutes.map(({ path, element }, i) => (
					<Route key={i} path={path} element={element} />
				))}
			</Routes>
		</>
	);
};

export default App;
